import { makeAutoObservable, action } from 'mobx';
import ApiStore from './ApiStore';
import AuthStore from './AuthStore';
import CompanyStore from './CompanyStore';
import FileStore from './FileStore';
import ModalStore from './ModalStore';
import UIStore from './UIStore';
import UserStore from './UserStore';

export default class RootStore {
    modalStore: ModalStore;
    apiStore: ApiStore;
    uiStore: UIStore;
    authStore: AuthStore;
    userStore: UserStore;
    companyStore: CompanyStore;
    fileStore: FileStore;

    constructor() {
        makeAutoObservable(this, {
            clearAllStore: action.bound
        });
        this.modalStore = new ModalStore(this);
        this.apiStore = new ApiStore(this);
        this.uiStore = new UIStore(this);
        this.authStore = new AuthStore(this);
        this.userStore = new UserStore(this);
        this.companyStore = new CompanyStore(this);
        this.fileStore = new FileStore(this);
    }

    clearAllStore() {
        this.userStore.clean();
        this.companyStore.clean();
    }
}
